import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../../reduxService/hooks';
import { endpoint } from '../../../../pages';
import { cleanProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { INewButtonProps } from './INewButton';
import './NewButton.scss';

const NewButton = (props: INewButtonProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const navigate = useNavigate();

    const handleClick = () => {
        dispatch(cleanProjectInfo());
        window.location.href = endpoint.newProject; // Navigate to the new project page
    };
    return (
        <button type="button" className={props.className} onClick={handleClick}>
            <i className="fa-solid fa-file-circle-plus" />
            {t('header_new_button')}
        </button>
    );
};

export default NewButton;
